exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(undefined);
// imports


// module
exports.push([module.id, ".contactForm input, .contactForm textarea {\n  width: 100%;\n  max-width: 500px;\n  margin: 5px; }\n.contactForm textarea {\n  height: 300px; }\n\n.clear {\n  clear: both; }\n", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader!./src/app/contact/contact.component.css
// module id = 362
// module chunks = 2